<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>
  <main class="container py-4">

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="fw-bold mb-0">Policy Fields</h4>
        <div class="text-muted small">
          Configure the dynamic fields users will complete in the KYC wizard
        </div>
      </div>

      <div class="d-flex gap-2">

        <button class="btn btn-outline-primary btn-sm" type="button" (click)="openDocuments()">
          Manage Documents
        </button>

        <button class="btn btn-outline-primary btn-sm" type="button" (click)="openRules()">
          Manage Rules
        </button>

        <button class="btn btn-outline-secondary btn-sm" (click)="back()">
          Back to Policy
        </button>
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4" *ngIf="policy">
      <div class="card-body">
        <div class="row g-3 small">
          <div class="col-md-4">
            <div class="text-muted">Policy</div>
            <div class="fw-semibold">{{ policy.name }}</div>
          </div>
          <div class="col-md-2">
            <div class="text-muted">Tier</div>
            <div class="fw-semibold">{{ policy.tierCode }}</div>
          </div>
          <div class="col-md-3">
            <div class="text-muted">Jurisdiction</div>
            <div class="fw-semibold">{{ policy.jurisdictionName }}</div>
          </div>
          <div class="col-md-3">
            <div class="text-muted">Version</div>
            <div class="fw-semibold">{{ policy.version }}</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="loading" class="text-center py-4">
      <div class="spinner-border"></div>
    </div>

    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <form [formGroup]="importForm" (ngSubmit)="importFields()" class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
          <div>
            <h5 class="mb-1">Import Fields</h5>
            <div class="text-muted small">
              Copy fields from another jurisdiction, tier, or policy into this policy.
            </div>
          </div>
        </div>

        <div class="row g-3 align-items-end">
          <div class="col-md-7">
            <label class="form-label">Source Policy</label>
            <select class="form-select" formControlName="sourcePolicyId">
              <option value="">Select source policy</option>
              <option *ngFor="let item of availableImportPolicies" [value]="item.id">
                {{ item.jurisdictionName || item.jurisdictionCode || item.jurisdictionId }} -
                {{ item.tierCode }} -
                {{ item.name }} v{{ item.version }}
              </option>
            </select>
            <div class="small text-danger mt-1" *ngIf="sourcePolicyId?.touched && sourcePolicyId?.invalid">
              Source policy is required.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Existing Fields</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="overwriteExisting" />
              <label class="form-check-label">Overwrite matching field keys</label>
            </div>
          </div>

          <div class="col-md-2">
            <button class="btn btn-outline-primary w-100" type="submit" [disabled]="importing">
              <span *ngIf="importing" class="spinner-border spinner-border-sm me-2"></span>
              Import
            </button>
          </div>
        </div>
      </div>
    </form>

    <form [formGroup]="form" (ngSubmit)="save()" class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <h5 class="mb-3">{{ editingId ? 'Edit Field' : 'New Field' }}</h5>

        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Field Key</label>
            <input class="form-control" formControlName="fieldKey" placeholder="firstName" />
            <div class="small text-danger mt-1" *ngIf="fieldKey?.touched && fieldKey?.invalid">
              Field key is required.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Label</label>
            <input class="form-control" formControlName="label" placeholder="First Name" />
            <div class="small text-danger mt-1" *ngIf="label?.touched && label?.invalid">
              Label is required.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Field Type</label>
            <select class="form-select" formControlName="fieldType">
              <option *ngFor="let item of fieldTypes" [value]="item">{{ item }}</option>
            </select>
          </div>

          <div class="col-md-2">
            <label class="form-label">Sort Order</label>
            <input class="form-control" type="number" min="0" formControlName="sortOrder" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Min Length</label>
            <input class="form-control" type="number" min="0" formControlName="minLength" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Max Length</label>
            <input class="form-control" type="number" min="0" formControlName="maxLength" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Regex Pattern</label>
            <input class="form-control" formControlName="regexPattern" placeholder="Optional regex" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Placeholder</label>
            <input class="form-control" formControlName="placeholder" placeholder="Placeholder text" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Help Text</label>
            <textarea class="form-control" rows="2" formControlName="helpText"></textarea>
          </div>

          <div class="col-md-12" *ngIf="isSelectField()">
            <label class="form-label">Select Options</label>

            <div formArrayName="options">
              <div class="row g-2 mb-2" *ngFor="let option of options.controls; let i = index" [formGroupName]="i">

                <div class="col-md-5">
                  <input class="form-control" formControlName="label" placeholder="Label e.g. Passport" />
                </div>

                <div class="col-md-5">
                  <input class="form-control" formControlName="value" placeholder="Value e.g. PASSPORT" />
                </div>

                <div class="col-md-2">
                  <button class="btn btn-outline-danger w-100" type="button" (click)="removeOption(i)">
                    Remove
                  </button>
                </div>
              </div>
            </div>

            <button class="btn btn-outline-primary btn-sm" type="button" (click)="addOption()">
              Add Option
            </button>

            <div class="form-text">
              Labels are shown to users. Values are saved and used by the backend.
            </div>
          </div>

          <div class="col-md-12" *ngIf="isDateField()">
            <label class="form-label">Date Validation</label>

            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label small text-muted">Minimum Date</label>

                <select class="form-select mb-2" formControlName="minDateMode">
                  <option value="">None</option>
                  <option value="today">Today</option>
                  <option value="custom">Custom date</option>
                </select>

                <input *ngIf="form.value.minDateMode === 'custom'" class="form-control" type="date"
                  formControlName="minDate" />
              </div>

              <div class="col-md-6">
                <label class="form-label small text-muted">Maximum Date</label>

                <select class="form-select mb-2" formControlName="maxDateMode">
                  <option value="">None</option>
                  <option value="today">Today</option>
                  <option value="custom">Custom date</option>
                </select>

                <input *ngIf="form.value.maxDateMode === 'custom'" class="form-control" type="date"
                  formControlName="maxDate" />
              </div>
            </div>

            <div class="form-text">
              Use maximum date = Today for date of birth. Use minimum date = Today for expiry dates.
            </div>
          </div>

          <div class="col-md-6" *ngIf="!isSelectField()">
            <label class="form-label">Options JSON</label>
            <textarea class="form-control" rows="2" formControlName="optionsJson"
              placeholder='[{"label":"Passport","value":"PASSPORT"}]'></textarea>
          </div>

          <div class="col-md-6" *ngIf="!isDateField()">
            <label class="form-label">Validation JSON</label>
            <textarea class="form-control" rows="2" formControlName="validationJson"
              placeholder='{"maxDate":"today"}'></textarea>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Required</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="isRequired" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Encrypted</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="isEncrypted" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>
        </div>

        <div class="mt-4 d-flex gap-2">
          <button class="btn btn-primary" type="submit" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
            {{ editingId ? 'Update Field' : 'Create Field' }}
          </button>

          <button class="btn btn-outline-secondary" type="button" (click)="resetForm()">
            Clear
          </button>
        </div>
      </div>
    </form>

    <div *ngIf="!loading && !items.length" class="alert alert-light border">
      No policy fields found.
    </div>

    <div *ngIf="items.length" class="card shadow-sm border-0">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Key</th>
              <th>Label</th>
              <th>Type</th>
              <th>Order</th>
              <th>Required</th>
              <th>Encrypted</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of items">
              <td class="fw-semibold">{{ item.fieldKey }}</td>
              <td>{{ item.label }}</td>
              <td>{{ item.fieldType }}</td>
              <td>{{ item.sortOrder }}</td>
              <td>{{ item.isRequired ? 'Yes' : 'No' }}</td>
              <td>{{ item.isEncrypted ? 'Yes' : 'No' }}</td>
              <td class="text-end">
                <div class="d-inline-flex gap-2">
                  <button class="btn btn-sm btn-outline-primary" (click)="edit(item)">Edit</button>
                  <button class="btn btn-sm btn-outline-danger" [disabled]="deletingId === item.id"
                    data-bs-toggle="modal" data-bs-target="#deletePolicyFieldModal" (click)="openDeleteModal(item)">
                    <span *ngIf="deletingId === item.id" class="spinner-border spinner-border-sm me-2"></span>
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>

<div class="modal fade" id="deletePolicyFieldModal" tabindex="-1" aria-labelledby="deletePolicyFieldModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <h5 class="modal-title fw-semibold" id="deletePolicyFieldModalLabel">Delete Policy Field</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          [disabled]="!!deletingId"></button>
      </div>

      <div class="modal-body">
        <div class="alert alert-warning py-2">
          This will remove the field from this policy.
        </div>

        <div *ngIf="fieldPendingDelete" class="border rounded p-3 bg-light-subtle">
          <div class="fw-semibold">{{ fieldPendingDelete.label }}</div>
          <div class="text-muted small">{{ fieldPendingDelete.fieldKey }}</div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" [disabled]="!!deletingId">
          Cancel
        </button>

        <button type="button" class="btn btn-danger" (click)="confirmDelete()"
          [disabled]="!!deletingId || !fieldPendingDelete">
          <span *ngIf="!!deletingId" class="spinner-border spinner-border-sm me-2"></span>
          Delete Field
        </button>
      </div>
    </div>
  </div>
</div>